import { assign } from '@thoughtspot/string-util';
import _ from 'lodash';
const ellipses = '...';
let canvasEl;
export const initMockCanvasEl = (element) => {
    canvasEl = element;
};
export function getMeasurementCanvasContext() {
    if (!canvasEl) {
        canvasEl = document.createElement('canvas');
    }
    return canvasEl.getContext('2d');
}
export function truncateTextToWidth(text, maxWidth, font) {
    if (!text) {
        return text;
    }
    const ctx = getMeasurementCanvasContext();
    ctx.font = font;
    const fullTextWidth = ctx.measureText(text).width;
    if (fullTextWidth <= maxWidth) {
        return text;
    }
    const averagePerCharacterWidth = fullTextWidth / text.length;
    const fixedWidthFontBestGuessFitSlice = text.substr(0, maxWidth / averagePerCharacterWidth);
    let beginIndex = 0;
    let endIndex = text.length;
    const ellipsesWidth = ctx.measureText(ellipses).width;
    if (ctx.measureText(fixedWidthFontBestGuessFitSlice).width <=
        maxWidth - ellipsesWidth) {
        beginIndex = fixedWidthFontBestGuessFitSlice.length;
    }
    else {
        endIndex = fixedWidthFontBestGuessFitSlice.length;
    }
    while (beginIndex < endIndex - 1) {
        const mid = Math.floor((beginIndex + endIndex) / 2);
        const sub = text.substr(0, mid);
        if (ctx.measureText(sub).width <= maxWidth - ellipsesWidth) {
            beginIndex = mid;
        }
        else {
            endIndex = mid;
        }
    }
    return endIndex > 1 ? text.substr(0, beginIndex) + ellipses : '';
}
export function getWidthForArrayOfStrings(labels, font, padding) {
    const ctx = getMeasurementCanvasContext();
    ctx.font = font;
    const totalWidth = ctx.measureText(labels.join('')).width + (labels.length - 1) * padding;
    return totalWidth;
}
export function getTextWidth(text, font) {
    const ctx = getMeasurementCanvasContext();
    ctx.font = font;
    const rv = ctx.measureText(text).width;
    return rv;
}
export class NameValuePairs {
    constructor(defaultMap) {
        this.nameValues = defaultMap || [];
        this.textTemplate = (name, value) => `${name}: ${value}`;
    }
    add(name, value) {
        this.nameValues.push({
            name,
            value,
        });
    }
    getTemplate() {
        let template = '<div>';
        const templateLine = '<div class="bk-tooltip"><span class="bk-tooltip-key">{1}: </span><span class="bk-tooltip-value">{2}</span></div>';
        this.nameValues.forEach(function (item) {
            if (!!item.name && !!item.value) {
                template += assign(templateLine, _.escape(item.name), _.escape(item.value));
            }
        });
        template += '</div>';
        return template;
    }
    getText() {
        return this.nameValues
            .map((item) => {
            return this.textTemplate(_.escape(item.name), _.escape(item.value));
        })
            .join('\n');
    }
}
//# sourceMappingURL=font-metric-service.js.map